module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/fontname.a96b420c.svg";